import http from "./../shared/axios";
import EncrDecrService from "../services/EncrDecrService.Service";
import { Lead_Create, Lead_Update, Lead_Ingestion_Two, Lead_Consent_Update } from "../shared/ServiceCommonEndpoints";
import { funcGenerateUniqueKey, getGEMID1, getGEMID2, getLastCs, getShortCode, getApiSubPayload } from "../shared/utility";
export default class SslService {
  static funcValidateOtpAndCreateSsl(personalInfo, otpInput, cardType, productType) {
    const middleNameval = personalInfo.middleName ? personalInfo.middleName.trim() : "";
    let personalDetails = {
      channelCode: personalInfo.channelCode,
      cardType: cardType,
      firstName: personalInfo.firstName,
      middleName: middleNameval,
      lastName: personalInfo.lastName,
      mobileNumber: personalInfo.mobileNo,
      consentFlag: "Y",
      reasonCode: "101",
      otp: otpInput,
      //currentCardType:personalInfo.currentCardType,
     // previousCardType:personalInfo.previousCardType,
     // currentNwType:personalInfo.currentNwType,
      priority:personalInfo.priority,
      productType:productType,
      networkSelected:personalInfo.isNwChanged,
      dsignString: funcGenerateUniqueKey(),
      lastCsDatetime: localStorage.getItem("lastCsDatetime") ? localStorage.getItem("lastCsDatetime") : "",
      sourceCode: localStorage.getItem("sourceCode") ? localStorage.getItem("sourceCode") : personalInfo.sourceCode,
    };
    let subPayload = getApiSubPayload();
    delete subPayload.shortCode;
    personalDetails = { ...personalDetails, ...subPayload };
    const sslData = {
      data: {
    	  ...personalDetails
      },
      action: otpInput ? "submit" : "submitWithoutAuth",
      type: "Swift App",
    };

    var encyMobile = EncrDecrService.set(personalInfo.mobileNo)

    return http.post(Lead_Create, sslData,
      {
        headers: {
          "IDENTIFIER_1": encyMobile,
          "IDENTIFIER_2": localStorage.getItem("visitorID"),
          "ENCRYPTED_ID": "1"
        }
      }
    );
  }

  static funcValidateOtpAndUpdateSsl(personalInfo, otpInput) {
    let header_val = {};
    if (otpInput) {
      var encyMobile = EncrDecrService.set(personalInfo.mobileNo)
      personalInfo.dsignString = funcGenerateUniqueKey();
      header_val = {
        "IDENTIFIER_1": encyMobile,
        "IDENTIFIER_2": localStorage.getItem("visitorID"),
        "ENCRYPTED_ID": "1"
      };
    } else {
      header_val = {
        "IDENTIFIER_1": personalInfo.shortCode,
        "IDENTIFIER_2": localStorage.getItem("visitorID"),
        "DeviceInfo": localStorage.getItem("deviceinfo"),
      };
    }
    const sslData = {
      data: {
        ...personalInfo
      },
      action: otpInput ? "UpdateWithOTPAuth" : "UpdateWithoutAuth",
      type: "Swift App",
    };
    return http.post(Lead_Consent_Update, sslData,
      {
        headers: header_val
      }
    );
  }

  static funcUpdateSSLByShortCodev1(userDetail, action) {
	  let userInfo = {...userDetail};
	      if (action === "updateProfSubmit") {
	        let gemId1 = getGEMID1();
	        let gemId2 = getGEMID2();
	        let lastCs = getLastCs();
	       // let shortCode = userDetail.shortCode ? userDetail.shortCode : getShortCode();
	        if(gemId1 && gemId1 !== "null" && gemId1 !== "" && gemId1 !== "undefined")
	        userInfo.gemId1 = gemId1;
	        if(gemId2 && gemId2 !== "null" && gemId2 !== "" && gemId2 !== "undefined")
	        userInfo.gemId2 = gemId2;
	        if(lastCs && lastCs !== "null" && lastCs !== "")
	        userInfo.lastCs = lastCs;
	       // if(shortCode && shortCode !== "null" && shortCode !== "")
	        // userInfo.shortCode = shortCode;
	      }
        //else if(action === "ChangeNetwork"){
          let shortCode = userDetail.shortCode ? userDetail.shortCode : getShortCode();
          if(shortCode && shortCode !== "null" && shortCode !== "")
	        userInfo.shortCode = shortCode;
        //}
    const sslUpdateData = {
      data: {
    	  ...userInfo,
      },
      action: action,
      type: "Swift App",
    };
    let mothersNameSign =  localStorage.getItem("dSignVPlusMotherName");
    let emailSign = localStorage.getItem("dSignVPlusEmailId");
    return http.post(Lead_Update, sslUpdateData, {
      headers: {  
        "IDENTIFIER_1": userDetail.shortCode,
        "IDENTIFIER_2": localStorage.getItem("visitorID"),
        "DeviceInfo": localStorage.getItem("deviceinfo"),
        "dSignVPlusMotherName" : mothersNameSign ? mothersNameSign : null ,
        "dSignVPlusEmailId" : emailSign ? emailSign : null
      }
    });
  }

  static funcInvokeIngestion2Service(resiAddrReq) {
    resiAddrReq = { ...resiAddrReq, ...getApiSubPayload() };
    const resiAddr = {
      data: {
        ...resiAddrReq,
      },
      action: "addressConfirm",
      type: "Swift App",
    };
    let addressSign = localStorage.getItem("dSignVPlusResiAddress");
    return http.post(Lead_Ingestion_Two, resiAddr, {
      headers: {
        "IDENTIFIER_1": resiAddrReq.applicationNumber,
        "IDENTIFIER_2": localStorage.getItem("visitorID"),
       "dSignVPlusResiAddress" : addressSign ? addressSign : null
      }
    });
  }
}
